export default __webpack_public_path__ + "static/media/grid.920bd338.png";